// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as CardRouteImport } from './routes/card'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as EasyLoverRouteImport } from './routes/easy-lover'
import { Route as ForAgentsRouteImport } from './routes/for-agents'
import { Route as FullStackDesignerRouteImport } from './routes/full-stack-designer'
import { Route as HiringRouteImport } from './routes/hiring'
import { Route as ImprintRouteImport } from './routes/imprint'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RefundsRouteImport } from './routes/refunds'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as VibeCodingAgencyRouteImport } from './routes/vibe-coding-agency'
import { Route as WebmcpRouteImport } from './routes/webmcp'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as EasyLoverIndexRouteImport } from './routes/easy-lover.index'
import { Route as EasyLoverPrivacyRouteImport } from './routes/easy-lover.privacy'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as GuidesBestAiAppBuildersRouteImport } from './routes/guides.best-ai-app-builders'
import { Route as GuidesExportDataFromLovableCloudRouteImport } from './routes/guides.export-data-from-lovable-cloud'
import { Route as GuidesHowToBuildAnMcpServerWithLovableRouteImport } from './routes/guides.how-to-build-an-mcp-server-with-lovable'
import { Route as GuidesIosSafariWhiteBarFixRouteImport } from './routes/guides.ios-safari-white-bar-fix'
import { Route as GuidesLovableVsCursorRouteImport } from './routes/guides.lovable-vs-cursor'
import { Route as GuidesVibeCodingHelpRouteImport } from './routes/guides.vibe-coding-help'
import { Route as GuidesWhatIsVibeCodingRouteImport } from './routes/guides.what-is-vibe-coding'
import { Route as LibraryIndexRouteImport } from './routes/library.index'
import { Route as LibrarySlugRouteImport } from './routes/library.$slug'
import { Route as LibraryBadgeRouteImport } from './routes/library.badge'
import { Route as LibraryCreatorsRouteImport } from './routes/library.creators'
import { Route as LibraryNewRouteImport } from './routes/library.new'
import { Route as LibrarySubmitRouteImport } from './routes/library.submit'
import { Route as PTokenRouteImport } from './routes/p.$token'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesAppDevelopmentConsultantRouteImport } from './routes/services.app-development-consultant'
import { Route as ServicesLovableCloudMigrationRouteImport } from './routes/services.lovable-cloud-migration'
import { Route as ServicesLovableDevelopmentRouteImport } from './routes/services.lovable-development'
import { Route as ServicesMvpDevelopmentRouteImport } from './routes/services.mvp-development'
import { Route as ServicesVibeCodingRescueRouteImport } from './routes/services.vibe-coding-rescue'
import { Route as WorkIndexRouteImport } from './routes/work.index'
import { Route as WorkSlugRouteImport } from './routes/work.$slug'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AdminClientsProfileIdRouteImport } from './routes/admin.clients.$profileId'
import { Route as AdminPreviewProfileIdRouteImport } from './routes/admin.preview.$profileId'
import { Route as LibraryBestIndexRouteImport } from './routes/library.best.index'
import { Route as LibraryBestSlugRouteImport } from './routes/library.best.$slug'
import { Route as LibraryByCreatorRouteImport } from './routes/library.by.$creator'
import { Route as LibraryCCategoryRouteImport } from './routes/library.c.$category'
import { Route as LibraryTTagRouteImport } from './routes/library.t.$tag'
import { Route as PTokenCertificateRouteImport } from './routes/p_.$token.certificate'
import { Route as PTokenContractRouteImport } from './routes/p_.$token.contract'
import { Route as LibraryCCategorySubRouteImport } from './routes/library.c.$category.$sub'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const CardRoute = CardRouteImport.update({
            id: '/card',path: '/card',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const EasyLoverRoute = EasyLoverRouteImport.update({
            id: '/easy-lover',path: '/easy-lover',getParentRoute: () => rootRouteImport
          })
const ForAgentsRoute = ForAgentsRouteImport.update({
            id: '/for-agents',path: '/for-agents',getParentRoute: () => rootRouteImport
          })
const FullStackDesignerRoute = FullStackDesignerRouteImport.update({
            id: '/full-stack-designer',path: '/full-stack-designer',getParentRoute: () => rootRouteImport
          })
const HiringRoute = HiringRouteImport.update({
            id: '/hiring',path: '/hiring',getParentRoute: () => rootRouteImport
          })
const ImprintRoute = ImprintRouteImport.update({
            id: '/imprint',path: '/imprint',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RefundsRoute = RefundsRouteImport.update({
            id: '/refunds',path: '/refunds',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const VibeCodingAgencyRoute = VibeCodingAgencyRouteImport.update({
            id: '/vibe-coding-agency',path: '/vibe-coding-agency',getParentRoute: () => rootRouteImport
          })
const WebmcpRoute = WebmcpRouteImport.update({
            id: '/webmcp',path: '/webmcp',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const EasyLoverIndexRoute = EasyLoverIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EasyLoverRoute
          })
const EasyLoverPrivacyRoute = EasyLoverPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => EasyLoverRoute
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesBestAiAppBuildersRoute = GuidesBestAiAppBuildersRouteImport.update({
            id: '/guides/best-ai-app-builders',path: '/guides/best-ai-app-builders',getParentRoute: () => rootRouteImport
          })
const GuidesExportDataFromLovableCloudRoute = GuidesExportDataFromLovableCloudRouteImport.update({
            id: '/guides/export-data-from-lovable-cloud',path: '/guides/export-data-from-lovable-cloud',getParentRoute: () => rootRouteImport
          })
const GuidesHowToBuildAnMcpServerWithLovableRoute = GuidesHowToBuildAnMcpServerWithLovableRouteImport.update({
            id: '/guides/how-to-build-an-mcp-server-with-lovable',path: '/guides/how-to-build-an-mcp-server-with-lovable',getParentRoute: () => rootRouteImport
          })
const GuidesIosSafariWhiteBarFixRoute = GuidesIosSafariWhiteBarFixRouteImport.update({
            id: '/guides/ios-safari-white-bar-fix',path: '/guides/ios-safari-white-bar-fix',getParentRoute: () => rootRouteImport
          })
const GuidesLovableVsCursorRoute = GuidesLovableVsCursorRouteImport.update({
            id: '/guides/lovable-vs-cursor',path: '/guides/lovable-vs-cursor',getParentRoute: () => rootRouteImport
          })
const GuidesVibeCodingHelpRoute = GuidesVibeCodingHelpRouteImport.update({
            id: '/guides/vibe-coding-help',path: '/guides/vibe-coding-help',getParentRoute: () => rootRouteImport
          })
const GuidesWhatIsVibeCodingRoute = GuidesWhatIsVibeCodingRouteImport.update({
            id: '/guides/what-is-vibe-coding',path: '/guides/what-is-vibe-coding',getParentRoute: () => rootRouteImport
          })
const LibraryIndexRoute = LibraryIndexRouteImport.update({
            id: '/library/',path: '/library/',getParentRoute: () => rootRouteImport
          })
const LibrarySlugRoute = LibrarySlugRouteImport.update({
            id: '/library/$slug',path: '/library/$slug',getParentRoute: () => rootRouteImport
          })
const LibraryBadgeRoute = LibraryBadgeRouteImport.update({
            id: '/library/badge',path: '/library/badge',getParentRoute: () => rootRouteImport
          })
const LibraryCreatorsRoute = LibraryCreatorsRouteImport.update({
            id: '/library/creators',path: '/library/creators',getParentRoute: () => rootRouteImport
          })
const LibraryNewRoute = LibraryNewRouteImport.update({
            id: '/library/new',path: '/library/new',getParentRoute: () => rootRouteImport
          })
const LibrarySubmitRoute = LibrarySubmitRouteImport.update({
            id: '/library/submit',path: '/library/submit',getParentRoute: () => rootRouteImport
          })
const PTokenRoute = PTokenRouteImport.update({
            id: '/p/$token',path: '/p/$token',getParentRoute: () => rootRouteImport
          })
const RTokenRoute = RTokenRouteImport.update({
            id: '/r/$token',path: '/r/$token',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const ServicesAppDevelopmentConsultantRoute = ServicesAppDevelopmentConsultantRouteImport.update({
            id: '/services/app-development-consultant',path: '/services/app-development-consultant',getParentRoute: () => rootRouteImport
          })
const ServicesLovableCloudMigrationRoute = ServicesLovableCloudMigrationRouteImport.update({
            id: '/services/lovable-cloud-migration',path: '/services/lovable-cloud-migration',getParentRoute: () => rootRouteImport
          })
const ServicesLovableDevelopmentRoute = ServicesLovableDevelopmentRouteImport.update({
            id: '/services/lovable-development',path: '/services/lovable-development',getParentRoute: () => rootRouteImport
          })
const ServicesMvpDevelopmentRoute = ServicesMvpDevelopmentRouteImport.update({
            id: '/services/mvp-development',path: '/services/mvp-development',getParentRoute: () => rootRouteImport
          })
const ServicesVibeCodingRescueRoute = ServicesVibeCodingRescueRouteImport.update({
            id: '/services/vibe-coding-rescue',path: '/services/vibe-coding-rescue',getParentRoute: () => rootRouteImport
          })
const WorkIndexRoute = WorkIndexRouteImport.update({
            id: '/work/',path: '/work/',getParentRoute: () => rootRouteImport
          })
const WorkSlugRoute = WorkSlugRouteImport.update({
            id: '/work/$slug',path: '/work/$slug',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AdminClientsProfileIdRoute = AdminClientsProfileIdRouteImport.update({
            id: '/clients/$profileId',path: '/clients/$profileId',getParentRoute: () => AdminRoute
          })
const AdminPreviewProfileIdRoute = AdminPreviewProfileIdRouteImport.update({
            id: '/preview/$profileId',path: '/preview/$profileId',getParentRoute: () => AdminRoute
          })
const LibraryBestIndexRoute = LibraryBestIndexRouteImport.update({
            id: '/library/best/',path: '/library/best/',getParentRoute: () => rootRouteImport
          })
const LibraryBestSlugRoute = LibraryBestSlugRouteImport.update({
            id: '/library/best/$slug',path: '/library/best/$slug',getParentRoute: () => rootRouteImport
          })
const LibraryByCreatorRoute = LibraryByCreatorRouteImport.update({
            id: '/library/by/$creator',path: '/library/by/$creator',getParentRoute: () => rootRouteImport
          })
const LibraryCCategoryRoute = LibraryCCategoryRouteImport.update({
            id: '/library/c/$category',path: '/library/c/$category',getParentRoute: () => rootRouteImport
          })
const LibraryTTagRoute = LibraryTTagRouteImport.update({
            id: '/library/t/$tag',path: '/library/t/$tag',getParentRoute: () => rootRouteImport
          })
const PTokenCertificateRoute = PTokenCertificateRouteImport.update({
            id: '/p_/$token/certificate',path: '/p/$token/certificate',getParentRoute: () => rootRouteImport
          })
const PTokenContractRoute = PTokenContractRouteImport.update({
            id: '/p_/$token/contract',path: '/p/$token/contract',getParentRoute: () => rootRouteImport
          })
const LibraryCCategorySubRoute = LibraryCCategorySubRouteImport.update({
            id: '/$sub',path: '/$sub',getParentRoute: () => LibraryCCategoryRoute
          })





const AdminRouteChildren = {
  AdminClientsProfileIdRoute: AdminClientsProfileIdRoute,AdminPreviewProfileIdRoute: AdminPreviewProfileIdRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const EasyLoverRouteChildren = {
  EasyLoverPrivacyRoute: EasyLoverPrivacyRoute,EasyLoverIndexRoute: EasyLoverIndexRoute
}

const EasyLoverRouteWithChildren = EasyLoverRoute._addFileChildren(EasyLoverRouteChildren)




const LibraryCCategoryRouteChildren = {
  LibraryCCategorySubRoute: LibraryCCategorySubRoute
}

const LibraryCCategoryRouteWithChildren = LibraryCCategoryRoute._addFileChildren(LibraryCCategoryRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,CardRoute: CardRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,DashboardRoute: DashboardRoute,DocsRoute: DocsRoute,EasyLoverRoute: EasyLoverRouteWithChildren,ForAgentsRoute: ForAgentsRoute,FullStackDesignerRoute: FullStackDesignerRoute,HiringRoute: HiringRoute,ImprintRoute: ImprintRoute,PrivacyRoute: PrivacyRoute,RefundsRoute: RefundsRoute,ResetPasswordRoute: ResetPasswordRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,VibeCodingAgencyRoute: VibeCodingAgencyRoute,WebmcpRoute: WebmcpRoute,AuthCallbackRoute: AuthCallbackRoute,CheckoutReturnRoute: CheckoutReturnRoute,GuidesBestAiAppBuildersRoute: GuidesBestAiAppBuildersRoute,GuidesExportDataFromLovableCloudRoute: GuidesExportDataFromLovableCloudRoute,GuidesHowToBuildAnMcpServerWithLovableRoute: GuidesHowToBuildAnMcpServerWithLovableRoute,GuidesIosSafariWhiteBarFixRoute: GuidesIosSafariWhiteBarFixRoute,GuidesLovableVsCursorRoute: GuidesLovableVsCursorRoute,GuidesVibeCodingHelpRoute: GuidesVibeCodingHelpRoute,GuidesWhatIsVibeCodingRoute: GuidesWhatIsVibeCodingRoute,LibrarySlugRoute: LibrarySlugRoute,LibraryBadgeRoute: LibraryBadgeRoute,LibraryCreatorsRoute: LibraryCreatorsRoute,LibraryNewRoute: LibraryNewRoute,LibrarySubmitRoute: LibrarySubmitRoute,PTokenRoute: PTokenRoute,RTokenRoute: RTokenRoute,ServicesAppDevelopmentConsultantRoute: ServicesAppDevelopmentConsultantRoute,ServicesLovableCloudMigrationRoute: ServicesLovableCloudMigrationRoute,ServicesLovableDevelopmentRoute: ServicesLovableDevelopmentRoute,ServicesMvpDevelopmentRoute: ServicesMvpDevelopmentRoute,ServicesVibeCodingRescueRoute: ServicesVibeCodingRescueRoute,WorkSlugRoute: WorkSlugRoute,GuidesIndexRoute: GuidesIndexRoute,LibraryIndexRoute: LibraryIndexRoute,ServicesIndexRoute: ServicesIndexRoute,WorkIndexRoute: WorkIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,LibraryBestSlugRoute: LibraryBestSlugRoute,LibraryByCreatorRoute: LibraryByCreatorRoute,LibraryCCategoryRoute: LibraryCCategoryRouteWithChildren,LibraryTTagRoute: LibraryTTagRoute,PTokenCertificateRoute: PTokenCertificateRoute,PTokenContractRoute: PTokenContractRoute,LibraryBestIndexRoute: LibraryBestIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)